export default __webpack_public_path__ + "static/media/home-creative-portfolio-img-02.ce9d3ed7.jpg";